import React from 'react';
import PropTypes from 'prop-types';

import LazyLoad from 'components/LazyLoad';
import Picture from 'components/Picture';
import RawImage from 'components/RawImage';

import { isNbcHostedUrlImage, getAimsSourceImage } from 'lib/isAimsUrl';

const Thumbnail = ({
  thumbnail,
  additionalStyles,
  label,
  responsiveFlavors,
  preview,
}) => {
  if (!isNbcHostedUrlImage(thumbnail)) {
    return (
      <RawImage
        src={thumbnail}
        alt={label}
        minWidth={100}
        minHeight={100}
        layout="fill"
        className={additionalStyles.raw}
      />
    );
  }

  return (
    <LazyLoad placeholder={false}>
      <Picture
        responsiveFlavors={responsiveFlavors}
        url={getAimsSourceImage(thumbnail)}
        className={additionalStyles.thumbnail}
        preview={preview}
        retina
      />
    </LazyLoad>
  );
};

Thumbnail.propTypes = {
  thumbnail: PropTypes.string.isRequired,
  additionalStyles: PropTypes.shape({
    raw: PropTypes.string,
    thumbnail: PropTypes.string,
  }),
  label: PropTypes.string,
  responsiveFlavors: PropTypes.shape({}),
  preview: PropTypes.shape({}),
};

Thumbnail.defaultProps = {
  additionalStyles: {
    raw: null,
    thumbnail: null,
  },
  label: '',
  responsiveFlavors: {},
  preview: {},
};

export default Thumbnail;
